"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaaSBackofficeClient = void 0;
const axios_1 = __importDefault(require("axios"));
class SaaSBackofficeClient {
    constructor(options) {
        this.axiosInstance = axios_1.default.create(options);
    }
    async request({ path, method, body, params = {}, query = undefined, headers = undefined, axiosOptions, }) {
        let requestUrl = path;
        Object.entries(params).forEach(([key, value]) => {
            requestUrl = requestUrl.replace(`:${key}`, `${value}`);
        });
        return this.axiosInstance(requestUrl, {
            headers,
            method,
            data: body,
            params: query,
            ...axiosOptions,
        });
    }
    get(path, options) {
        return this.request({
            ...options,
            method: 'GET',
            path,
        });
    }
    post(path, body, options) {
        return this.request({
            ...options,
            method: 'POST',
            path,
            body,
        });
    }
    patch(path, body, options) {
        return this.request({
            ...options,
            method: 'PATCH',
            path,
            body,
        });
    }
    delete(path, options) {
        return this.request({
            ...options,
            method: 'DELETE',
            path,
        });
    }
}
exports.SaaSBackofficeClient = SaaSBackofficeClient;
//# sourceMappingURL=saas-backoffice-client.js.map